<template>
  <Container>
    <ButtonBack
      data-test-id="ImplementationGuidesPage__backButton"
      text="Back to Pricing"
      @click="handleBackToPricing"
    />
    <div :class="$style.header">
      <HeadingHuge>
        Implementation Guides
      </HeadingHuge>
      <HeadingSmall
        :class="$style.subheader"
        weight="normal"
      >
        Plan your JumpCloud rollout with peace of mind
      </HeadingSmall>
    </div>
    <Grid :class="$style.guides">
      <GridItem
        v-for="guide in implementationGuides"
        :key="guide.name"
        :gridSpan="6"
      >
        <ImplementationGuide
          :name="guide.name"
          :phases="guide.phases"
          :shortTimeline="guide.shortTimeline"
        />
      </GridItem>
      <GridItem :gridSpan="12">
        <ContactProfessionalServices />
      </GridItem>
    </Grid>
    <PricingFooter data-test-id="ImplementationGuidesPage__footer" />
  </Container>
</template>
<script>
import {
  ButtonBack,
  Container,
  Grid,
  GridItem,
  HeadingHuge,
  HeadingSmall,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import ContactProfessionalServices from 'client/Pricing/ImplementationGuides/ContactProfessionalServices.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ImplementationGuide from 'client/Pricing/ImplementationGuides/ImplementationGuide.vue';
import ImplementationGuideConstants from 'client/Pricing/ImplementationGuides/ImplementationGuideConstants';
import PricingFooter from 'client/Pricing/PricingFooter.vue';

const {
  description,
  location,
  text,
  section,
  toUrl,
} = eventProperties;

const {
  implementationGuidesPage,
} = eventLocations;

export default {
  name: 'ImplementationGuidesPage',

  EventHelper,

  components: {
    ButtonBack,
    ContactProfessionalServices,
    Container,
    Grid,
    GridItem,
    HeadingHuge,
    HeadingSmall,
    ImplementationGuide,
    PricingFooter,
  },

  data() {
    return {
      fairUsePolicyLink: 'https://jumpcloud.com/fair-use-policy',
      implementationGuides: ImplementationGuideConstants.ImplementationGuides,
    };
  },

  methods: {
    handleBackToPricing() {
      const pricingRoute = ItemTypeRoutes[ItemTypeConsts.pricing];
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'open pricing page',
        [location]: implementationGuidesPage,
        [section]: 'Header',
        [text]: 'Back to Pricing',
        [toUrl]: pricingRoute,
      });
      this.$router.push(pricingRoute);
    },
  },
};
</script>
<style scoped module>
.guides {
  margin: var(--jc-spacer-large);
}

.header {
  text-align: center;
}

.subheader {
  color: var(--jc-text-color-light);
}
</style>
